export enum RoleEnum {
    Admin = "Admin",
    User = "User",
    Organiser = "Organiser"
}
